import { cn } from "@/lib/utils";

interface ImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}

/**
 * Given an uploaded image URL like /uploads/services/uuid/full.webp,
 * generates srcSet with medium (800w), small (400w), xsmall (150w) variants.
 */
function buildSrcSet(src: string): string | undefined {
  // Only generate srcSet for our upload URLs
  const match = src.match(/^(\/uploads\/[^/]+\/[^/]+\/)full\.webp$/);
  if (!match) return undefined;

  const base = match[1];
  return [
    `${base}xsmall.webp 150w`,
    `${base}small.webp 400w`,
    `${base}medium.webp 800w`,
    `${base}full.webp 1600w`,
  ].join(", ");
}

export function Img({ src, alt, className, sizes, ...props }: ImgProps) {
  const srcSet = buildSrcSet(src);

  return (
    <img
      src={src}
      srcSet={srcSet}
      sizes={sizes || (srcSet ? "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" : undefined)}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={cn(className)}
      {...props}
    />
  );
}
